import { useContext, useEffect, useState } from "react";
import {useNavigate, useParams} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCaretRight,faCaretLeft, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import {AuthContext} from './../Auth/AuthProvider';
import ProductsService from "../services/ProductsService";
import CartService from "../services/CartService";
export default function SingleProduct() {
  const [product,setProduct] = useState({});
  const {productID} = useParams();
  const [currentImage, setCurrentImage] = useState("");
  const navigator = useNavigate();
  const [cart,setCart] = useState({itemId: "",selectedSize: "",quantity: 1,price:0});
  const auth = useContext(AuthContext);
  const [currentImageIndex,setCurrentImageIndex]=useState(1);
  const [isLoading,setIsLoading] = useState(true);
  useEffect(()=>{
    window.scrollTo(0, 0);
    ProductsService.getSingleProduct(productID).then((res)=>{
      setProduct(res.data);
      setCurrentImage(res.data.image);
    }).catch((err)=>{
      navigator("/not-found");
      setIsLoading(false);
    }).finally(()=>{
      setIsLoading(false);
    })
  },[navigator,productID]);
  const submitCart = () => {
    auth.getData(); 
    if(cart.selectedSize==="") {
      alert("please select size");
    }
    else if(cart.quantity==0) {
      alert("Quantity can not be zero")
    }
    else if(Object.keys(auth.userData).length === 0) {
      navigator("/users/login");
    }
    else {
      CartService.addToCart(cart).then((res)=>{
        navigator("/users/cart");
      }).catch((err)=>{
        alert(err.response.data.errorMessage);
      })
    }
  }
  const handlePrev = () => {
    const images = [product.image, product.image2, product.image3, product.image4, product.image5];
    setCurrentImageIndex(prev => {
      const newIndex = prev === 1 ? images.length : prev - 1;
      setCurrentImage(images[newIndex - 1]);
      return newIndex;
    });
  }
  const handleNext = () => {
    setCurrentImageIndex(prev => prev === images.length ? 1 : prev + 1);
    const images = [product.image, product.image2, product.image3, product.image4, product.image5];
    setCurrentImage(images[currentImageIndex % images.length]);
  }
  if(isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
        <div className="w-full max-w-3xl bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden">
          <div className="flex flex-col md:flex-row animate-pulse">
            <div className="md:w-1/2 bg-gray-100 dark:bg-gray-700 p-4">
              <div className="w-full h-80 bg-gray-300 dark:bg-gray-600 rounded-md" />
            </div>
            <div className="md:w-1/2 p-6 space-y-4">
              <div className="h-6 w-3/4 bg-gray-300 dark:bg-gray-600 rounded" />
              <div className="flex gap-4">
                <div className="h-4 w-20 bg-gray-300 dark:bg-gray-600 rounded" />
                <div className="h-4 w-20 bg-gray-300 dark:bg-gray-600 rounded" />
              </div>
              <div className="space-y-2">
                <div className="h-4 w-16 bg-gray-300 dark:bg-gray-600 rounded" />
                <div className="flex gap-2">
                  {[1, 2, 3, 4].map(i => (
                    <div
                      key={i}
                      className="h-8 w-10 bg-gray-300 dark:bg-gray-600 rounded"
                    />
                  ))}
                </div>
              </div>
              <div className="space-y-2">
                <div className="h-4 w-20 bg-gray-300 dark:bg-gray-600 rounded" />
                <div className="h-4 w-32 bg-gray-300 dark:bg-gray-600 rounded" />
              </div>
              {[1, 2, 3, 4].map(i => (
                <div key={i} className="h-4 w-40 bg-gray-300 dark:bg-gray-600 rounded" />
              ))}
              <div className="flex gap-4 pt-4">
                <div className="h-10 w-32 bg-gray-300 dark:bg-gray-600 rounded" />
                <div className="h-10 w-full bg-gray-300 dark:bg-gray-600 rounded" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 p-4 transition-colors duration-500">
      <div className="w-full max-w-3xl bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden transition-colors duration-500">
        <div className="flex flex-col md:flex-row">
          <div className="md:w-1/2 flex flex-col justify-center bg-gray-100 dark:bg-gray-700 transition-colors duration-500 p-4">
            <div className="w-full overflow-hidden relative">
              <img src={currentImage} alt={product.name}
                loading="lazy"
                className="w-full object-fit rounded-md transition-all duration-500"
              />
              <button onClick={handlePrev} className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 rounded-full hover:bg-black transition" aria-label="Previous image">
                <FontAwesomeIcon icon={faCaretLeft} size="lg" />
              </button>
              <button onClick={handleNext} className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 rounded-full hover:bg-black transition"aria-label="Next image">
                <FontAwesomeIcon icon={faCaretRight} size="lg" />
              </button>
            </div>
          </div>
          <div className="md:w-1/2 p-6 flex flex-col justify-center transition-colors duration-500">
            <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-white transition-colors duration-500">{product.name}</h2>
            <div className="flex flex-row gap-5">
              <p className="text-md font-semibold mb-2 transition-colors duration-500 line-through">₹ {product.actualPrice}</p>
              <p className="text-md font-semibold mb-2 transition-colors duration-500">₹ {product.price}</p>
            </div>
            <div className="mb-4">
              <span className="block text-gray-600 dark:text-gray-300 font-medium transition-colors duration-500">Size</span>
              <div className="flex flex-row gap-2 mt-1">
                {(product.sizes || ["S", "M", "L", "XL"]).map((size, idx) => (
                  <span key={idx} onClick={() => setCart({itemId: productID,selectedSize: size,quantity: 1,price:product.price})} className={`${cart.selectedSize === size ? 'bg-amber-800 text-white' : 'bg-none'} ${product.size?.[size]===0? 'hidden' : 'flex'} px-3 py-1 border font-black border-amber-600 hover:bg-amber-700 cursor-pointer  text-gray-800 dark:text-white text-sm transition-all duration-500`}>
                    {size}
                  </span>
                ))}
              </div>
            </div>
            <div className="mb-2">
              <span className="block text-gray-600 dark:text-gray-300 font-bold transition-colors duration-500">Fabric</span>
              <span className="text-gray-800 dark:text-white transition-colors duration-500">{product.fabric}</span>
            </div>
            <div className="mb-2">
              <details className="group">
                <summary className="cursor-pointer list-none">
                  <span className="block text-gray-600 dark:text-gray-300 font-bold transition-colors duration-500">
                    <FontAwesomeIcon icon={faCaretRight} className="px-1 group-open:hidden" />
                    <FontAwesomeIcon icon={faCaretDown} className="px-1 hidden group-open:inline" />
                    Description
                  </span>
                </summary>
                <div className="mt-2 text-gray-800 dark:text-white transition-colors duration-500">
                  {product.description}
                </div>
              </details>
            </div>
            <div className="mb-2">
              <details className="group">
                <summary className="cursor-pointer list-none">
                  <span className="block text-gray-600 dark:text-gray-300 font-bold transition-colors duration-500">
                    <FontAwesomeIcon icon={faCaretRight} className="px-1 group-open:hidden" />
                    <FontAwesomeIcon icon={faCaretDown} className="px-1 hidden group-open:inline" />
                    Wash Care
                  </span>
                </summary>
                <div className="mt-2 text-gray-800 dark:text-white transition-colors duration-500">
                  {product.washcare}
                </div>
              </details>
            </div>
            <div className="mb-2">
              <details className="group">
                <summary className="cursor-pointer list-none">
                  <span className="block text-gray-600 dark:text-gray-300 font-bold transition-colors duration-500">
                    <FontAwesomeIcon icon={faCaretRight} className="px-1 group-open:hidden" />
                    <FontAwesomeIcon icon={faCaretDown} className="px-1 hidden group-open:inline" />
                    Details 
                  </span>
                </summary>
                <div className="mt-2 text-gray-800 dark:text-white transition-colors duration-500">
                  {product.details}
                </div>
              </details>
            </div>
            <div className="mb-2">
              <details className="group">
                <summary className="cursor-pointer list-none">
                  <span className="block text-gray-600 dark:text-gray-300 font-bold transition-colors duration-500">
                    <FontAwesomeIcon icon={faCaretRight} className="px-1 group-open:hidden" />
                    <FontAwesomeIcon icon={faCaretDown} className="px-1 hidden group-open:inline" />
                    Specification 
                  </span>
                </summary>
                <div className="mt-2 text-gray-800 dark:text-white transition-colors duration-500">
                  {product.specifications}
                </div>
              </details>
            </div>
            <div className="w-full flex flex-row justify-evenly">
              <div className="w-full flex items-center justify-between border rounded-md overflow-hidden">
                <button className="px-4 py-2 text-lg font-bold" onClick={()=>cart.quantity > 1 && setCart(prev=>({...prev,quantity:prev.quantity-1}))}>-</button>
                <span className="px-4 font-semibold">{cart.quantity}</span>
                <button className="px-4 py-2 text-lg font-bold" onClick={()=>setCart(prev=>({...prev,quantity:prev.quantity+1}))}>+</button>
              </div>
              <button className="w-full bg-black text-white rounded-md font-semibold" onClick={submitCart}>
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
